//  ShippitConfiguration.aspx
(function (backOffice, $) {
    backOffice.ShippitConfiguration = (function() {

        var tabPanelClientId = 'shippit_configuration_tabs';
        var apiKeysTable = '#api_keys_table';
        var apiKeysErrorAlertBox = '#api_keys_error_alert_box';
        var apiKeysSuccessAlertBox = '#api_keys_success_alert_box';
        var apiKeyErrorSpanClass = 'api-key-error';
        var confirmationModal = '#back_confirmation_modal';
        var apiKeysTabErrorIcon = '#api_keys_tab_error_icon';

        var deliveryServicesTable = '#delivery_services_table';
        var deliveryServicesErrorAlertBox = '#delivery_services_error_alert_box';
        var deliveryServicesSuccessAlertBox = '#delivery_services_success_alert_box';
        var deliveryServicesTabErrorIcon = '#delivery_services_tab_error_icon';
        var deliveryServiceErrorSpanClass = 'delivery-service-error';

        var settingsErrorAlertBox = '#settings_error_alert_box';
        var settingsSuccessAlertBox = '#settings_success_alert_box';
        var orderReferenceSelect = '#order_reference';
        var settingsTabErrorIcon =  '#settings_tab_error_icon';

        var baseApiPath = window.location.origin + '/dotnet/admin/api/';

        var areKeysValid, areServicesSavedSuccessfully;
        var areKeysChanged, areServicesChanged, areSettingsChanged;
        var areServicesInitialized, areSettingsInitialized;

        var tabs = {
            ApiKeys: 0,
            DeliveryServices: 1,
            Settings: 2
        }

        var orderReferences = {
            RetailExpressOrderNumber:
            {
                DisplayName: "Retail Express Order Number",
                Value: "RetailExpressOrderNumber"
            },
            ExternalReference: {
                DisplayName: "External Reference",
                Value: "ExternalReference"
            }
        }

        var deliveryServices = {
            Default: {
                DisplayName: "-- Please Select --",
                Value: "None"
            },
            DoNotSendToShippit: {
                DisplayName: "Do not send to Shippit",
                Value: "DoNotSendToShippit"
            },
            Standard: {
                DisplayName: "Standard",
                Value: "Standard"
            },
            Express: {
                DisplayName: "Express",
                Value: "Express"
            },
            Priority: {
                DisplayName: "Priority",
                Value: "Priority"
            }
        }

        var callApi = function (endpoint, data, method, successCallback, errorCallback) {
            $.ajax({
                url: baseApiPath + endpoint,
                method: method,
                data: data,
                contentType: 'application/json',
                success: successCallback,
                error: errorCallback
            });
        }

        var showTabAlertIcon = function(iconId, tabIndex) {
            $(iconId).removeClass("hide");
            $(iconId).addClass("display");

            document.getElementById(tabPanelClientId).control.set_activeTabIndex(tabIndex);
        }
        
        var hideTabAlertIcon = function(iconId) {
            $(iconId).removeClass("display");
            $(iconId).addClass("hide");
        }

        var showCellValidationError = function(tr, errorSpanClass, errorMessage) {
            tr.classList.add('has-error');
            var errorSpan = tr.getElementsByClassName(errorSpanClass)[0];
            errorSpan.textContent = errorMessage;
            errorSpan.style.display = 'inline';
        }

        var hideCellValidationError = function(tr, errorSpanClass) {
            tr.classList.remove('has-error');
            tr.getElementsByClassName(errorSpanClass)[0].style.display = 'none';
        }

        var initialize = function () { 
            BackOffice.ToggleLoader(true);

            initializeApiKeysTab();
        }

        var initializeApiKeysTab = function () {
            BackOffice.ToggleLoader(true);

            areKeysValid = true;
            areKeysChanged = false;

            $(apiKeysErrorAlertBox).hide();
            $(apiKeysSuccessAlertBox).hide();
            hideTabAlertIcon(apiKeysTabErrorIcon);

            getOutlets();

            $(document).one('ajaxStop', function () {
                BackOffice.ToggleLoader(false);
            });
        };

        var getOutlets = function () {
            var outlets = [];
            var apiKeys = [];

            callApi('getenabledoutlets', null, 'get', function (result) {
                outlets = result;
            });

            callApi('getshippitapikeys', null, 'get', function (result) {
                apiKeys = result;
            });

            $(document).one('ajaxStop', function () {
                apiKeys.forEach(function (key) {
                    var outlet = outlets.filter(o => o.id == key.outletModel.outletId);

                    if (outlet.length > 0) {    //  filter returns a new array so we will check the length
                        outlet[0].apiKey = key.outletModel.apiKey;  //  use the first item in the returned array
                        outlet[0].configurationId = key.id;
                    }
                });

                outlets.forEach(outlet => addOutlet(outlet));
            });
        };

        var addOutlet = function(outlet) {
            var validationSpanTemplate = "<span class='" + apiKeyErrorSpanClass + "' style='display: none'></span>";

            var apiKeyInputCellTemplate = "<td><input data-initial='" + (outlet.apiKey || "") + "' value='" + (outlet.apiKey || "") + "' "
                + "data-configuration-id='" + (outlet.configurationId || "") + "' type='text'/>" + validationSpanTemplate + "</td>";

            var row = "<tr data-id='" + outlet.id + "'><td>" + outlet.name + "</td>" + apiKeyInputCellTemplate + "</tr>";
            
            $(apiKeysTable + ' tbody').append(row);
        }

        var saveApiKeys = function () {
            $(apiKeysSuccessAlertBox).hide();
            $(apiKeysErrorAlertBox).hide();
            hideTabAlertIcon(apiKeysTabErrorIcon);
            areKeysValid = true;
            areKeysChanged = false;

            $(apiKeysTable + ' > tbody  > tr:not(:first-child)').each(function (index, tr) {
                var apiKey = $(tr).find('input').val();
                var initialApiKeyValue = $(tr).find('input').data('initial');
                
                if (apiKey != initialApiKeyValue) {
                    areKeysChanged = true;
                    if (apiKey == "") {
                        callApi('deleteshippitapikey/' + $(tr).find('input').data('configuration-id'), null, 'post',
                            function() {
                                onSuccessfulApiKeySave(tr, '', '');
                            },
                            function(error) {
                                areKeysValid = false;
                                onFailedApiKeySave(tr, error.responseJSON.exceptionMessage);
                            }
                        );
                    }
                    else {
                        var model = extractApiKeyOutletModel(tr);

                        callApi('saveshippitapikey', JSON.stringify(model), 'post',
                            function (result) {
                                    onSuccessfulApiKeySave(tr, apiKey, result);
                            },
                            function (error) {
                                areKeysValid = false;
                                onFailedApiKeySave(tr, error.responseJSON.exceptionMessage);
                            }
                        );
                    }
                }

                else {
                    hideCellValidationError(tr, apiKeyErrorSpanClass);
                }
            });

            $(document).one('ajaxStop', function () {
                if (areKeysValid && areKeysChanged) {
                    $(apiKeysSuccessAlertBox).show();
                }
                if(!areKeysValid) {
                    $(apiKeysErrorAlertBox).show();
                    showTabAlertIcon(apiKeysTabErrorIcon, tabs.ApiKeys);
                }
            });
        }
        
        var checkOnChosenDeliveryOption = function(tr, deliveryService) {
            var isChosen = true;
            if (deliveryService === deliveryServices.Default.Value) {
                areServicesSavedSuccessfully = false;
                isChosen = false;

                showCellValidationError(tr, deliveryServiceErrorSpanClass, "Please select a Delivery Service mapping for this Freight Type");
            }
            else{
                hideCellValidationError(tr, deliveryServiceErrorSpanClass)
            }
            return isChosen;
        }

        var saveDeliveryServices = function () {
            $(deliveryServicesSuccessAlertBox).hide();
            $(deliveryServicesErrorAlertBox).hide();
            hideTabAlertIcon(deliveryServicesTabErrorIcon);
            areServicesSavedSuccessfully = true;
            areServicesChanged = false;

            $(deliveryServicesTable + ' > tbody  > tr:not(:first-child)').each(function (index, tr) {
                var deliveryService = $(tr).find('select').val();
                var initialDeliveryService = $(tr).find('select').data('initial');

                if (checkOnChosenDeliveryOption(tr, deliveryService) && deliveryService != initialDeliveryService) {
                    areServicesChanged = true;
                    var model = extractDeliveryServiceMappingModel(tr);

                        callApi('saveshippitdeliveryservicemapping', JSON.stringify(model), 'post',
                            function (result) {
                                $(tr).find('select').data('initial', deliveryService);
                                $(tr).find('select').data('configuration-id', result);
                            },
                            function (error) {
                                areServicesSavedSuccessfully = false;
                            }
                        );
                }
            });
            if (!areServicesSavedSuccessfully){
                $(deliveryServicesErrorAlertBox).show();
                showTabAlertIcon(deliveryServicesTabErrorIcon, tabs.DeliveryServices);
            }

            $(document).one('ajaxStop', function () {
                if (areServicesSavedSuccessfully && areServicesChanged) {
                    $(deliveryServicesSuccessAlertBox).show();
                }
                
                if(!areServicesSavedSuccessfully) {
                    $(deliveryServicesErrorAlertBox).show();
                    showTabAlertIcon(deliveryServicesTabErrorIcon, tabs.DeliveryServices);
                }
            });
        }

        var save = function () {
            saveApiKeys();

            if (areServicesInitialized) {
                saveDeliveryServices();
            }

            if (areSettingsInitialized) {
                saveSettings();
            }

            if (areKeysChanged || areServicesChanged || areSettingsChanged) {
                BackOffice.ToggleLoader(true);
            }

            $(document).one('ajaxStop', function () {
                BackOffice.ToggleLoader(false);
           });
        }

        var extractApiKeyOutletModel = function(tr) {
            return {
                Id: $(tr).find('input').data('configuration-id'),
                OutletModel: {
                    ApiKey: $(tr).find('input').val(),
                    OutletName: $(tr).find("td").html(),
                    OutletId: tr.getAttribute('data-id')
                }
            }
        }

        var extractDeliveryServiceMappingModel = function (tr) {
            return {
                Id: $(tr).find('select').data('configuration-id'),
                MappingModel: {
                    DeliveryService: $(tr).find('select').val(),
                    FreightTypeName: $(tr).find("td").html(),
                    FreightTypeId: tr.getAttribute('data-id')
                }
            }
        }

        var onSuccessfulApiKeySave = function (tr, apiKey, configurationId) {
            hideCellValidationError(tr, apiKeyErrorSpanClass);
            $(tr).find('input').data('initial', apiKey);
            $(tr).find('input').data('configuration-id', configurationId);
        }

        var onFailedApiKeySave = function(tr, message) {
            showCellValidationError(tr, apiKeyErrorSpanClass, 'API Key could not be validated (' + message + ')');
        }

        var goBack = function () {
            var unsavedChanges = false;

            $(apiKeysTable + ' > tbody  > tr:not(:first-child)').each(function(index, tr) {
                var apiKey = $(tr).find('input').val();
                var initialApiKeyValue = $(tr).find('input').data('initial');

                unsavedChanges = unsavedChanges || apiKey != initialApiKeyValue;
            });

            $(deliveryServicesTable + ' > tbody  > tr:not(:first-child)').each(function (index, tr) {
                var deliveryService = $(tr).find('select').val();
                var initialDeliveryService = $(tr).find('select').data('initial');

                unsavedChanges = unsavedChanges || deliveryService != initialDeliveryService;
            });

            if (unsavedChanges) {
                $(confirmationModal).modal('show');
                return false;
            }

            return true;
        }

        var initializeDeliveryServices = function () {
            BackOffice.ToggleLoader(true);

            areServicesSavedSuccessfully = true;
            areServicesChanged = false;

            $(deliveryServicesErrorAlertBox).hide();
            $(deliveryServicesSuccessAlertBox).hide();
            hideTabAlertIcon(deliveryServicesTabErrorIcon);
            
            getFreightTypes();

            areServicesInitialized = true;

            $(document).one('ajaxStop', function () {
                BackOffice.ToggleLoader(false);
            });
        }

        var getFreightTypes = function () {
            var freightTypes = [];
            var deliveryServices = [];

            callApi('getfreighttypes', null, 'get', function (result) {
                freightTypes = result;
            });

            callApi('getshippitdeliveryservicemappings', null, 'get', function (result) {
                deliveryServices = result;
            });
            
            $(document).one('ajaxStop', function () {
                deliveryServices.forEach(function (service) {
                    var freightType = freightTypes.filter(f => f.id == service.mappingModel.freightTypeId);

                    if (freightType.length > 0) {
                        freightType[0].deliveryService = service.mappingModel.deliveryService;
                        freightType[0].configurationId = service.id;
                    }
                });

                freightTypes.forEach(freightType => addFreightType(freightType));
            });
        }

        var addFreightType = function (freightType) {
            var validationSpanTemplate = "<span class='" + deliveryServiceErrorSpanClass + "' style='display: none'></span>";

            var deliveryServiceOptions = "<option value='" + deliveryServices.Default.Value + "' " + (freightType.deliveryService ? "" : "selected") + ">" + deliveryServices.Default.DisplayName + "</option>"
                + getOption(deliveryServices.DoNotSendToShippit, freightType.deliveryService) 
                + getOption(deliveryServices.Standard, freightType.deliveryService) 
                + getOption(deliveryServices.Express, freightType.deliveryService) 
                + getOption(deliveryServices.Priority, freightType.deliveryService);

            var deliveryServiceSelectTemplate = "<td><select data-initial='" + (freightType.deliveryService || deliveryServices.Default.Value) + "' data-configuration-id='" 
                + (freightType.configurationId || "") + "'>"  + deliveryServiceOptions + "</select>" + validationSpanTemplate + "</td>";

            var row = "<tr data-id='" + freightType.id + "'><td>" + freightType.name + "</td>" + deliveryServiceSelectTemplate + "</tr>";

            $(deliveryServicesTable + ' tbody').append(row);
        }

        var getOption = function (deliveryServiceOption, currentService) {
            return "<option value='" + deliveryServiceOption.Value + "' "
                + (currentService === deliveryServiceOption.Value ? "selected" : "") + ">" + deliveryServiceOption.DisplayName + "</option>";
        }

        var initializeSettings = function () {
            BackOffice.ToggleLoader(true);

            $(settingsErrorAlertBox).hide();
            $(settingsSuccessAlertBox).hide();
            hideTabAlertIcon(settingsTabErrorIcon);

            $(orderReferenceSelect).append(new Option(orderReferences.RetailExpressOrderNumber.DisplayName, orderReferences.RetailExpressOrderNumber.Value, true));
            $(orderReferenceSelect).append(new Option(orderReferences.ExternalReference.DisplayName, orderReferences.ExternalReference.Value)); 

            getOrderReference();

            areSettingsInitialized = true;

            $(document).one('ajaxStop', function () {
                BackOffice.ToggleLoader(false);
            });
        }

        var saveSettings = function () {
            $(settingsErrorAlertBox).hide();
            $(settingsSuccessAlertBox).hide();
            hideTabAlertIcon(settingsTabErrorIcon);
            areSettingsChanged = false;

            if ($(orderReferenceSelect).data('initial') != $(orderReferenceSelect).val()) {
                areSettingsChanged = true;
                var model = {
                    ConfigurationModel: {
                        OrderReference: $(orderReferenceSelect).val()
                    }
                }

                callApi('saveserviceconfiguration', JSON.stringify(model), 'post',
                    function (result) {
                        $(orderReferenceSelect).data('initial', result.configurationModel.orderReference);
                        $(settingsSuccessAlertBox).show();
                    },
                    function (error) {
                        $(settingsErrorAlertBox).show();
                        showTabAlertIcon(settingsTabErrorIcon, tabs.Settings);
                    }
                );
            }
        }

        var getOrderReference = function () {
            callApi('getserviceconfiguration', null, 'get', function (result) {
                if (result.configurationModel.orderReference != null) {
                    $(orderReferenceSelect).val(result.configurationModel.orderReference);
                    $(orderReferenceSelect).data('initial', result.configurationModel.orderReference);
                }
            });
        }

        var activeTabChanged = function (sender) {
            currentTabIndex = sender.get_activeTabIndex();

            if (currentTabIndex == tabs.DeliveryServices && !areServicesInitialized) {
                initializeDeliveryServices();
            }
            if (currentTabIndex == tabs.Settings && !areSettingsInitialized) {
                initializeSettings();
            }
        }

        return $.extend(backOffice.ShippitConfiguration, {
            Init: initialize,
            Save: save,
            GoBack: goBack,
            ActiveTabChanged: activeTabChanged
        });
    })();

    return backOffice.ShippitConfiguration;
})(BackOffice || {}, jQuery);